<script>
export default {
  name: 'RadioOnOff',
  emits: ['update:modelValue'],
  props: {
    propId: String,
    propTitle: String,
    propOnTitle: {type: String, default: 'On'},
    propOffTitle: {type: String, default: 'Off'},
    propTooltipText: {type: String, default: null},
    modelValue: Boolean,
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
}

</script>

<template>
  <div class="row mb-1">
    <div class="col-6 pt-1">
      <span class="me-1">{{ propTitle }}</span>
      <i class="bi bi-info-circle tooltip-slider-init cursor-pointer"
         data-bs-toggle="tooltip"
         data-bs-html="true"
         v-if="propTooltipText !== null"
         :data-bs-title='`<small>${propTooltipText}`'></i>
    </div>
    <div class="col-6 text-end">
      <div class="btn-group btn-group-sm w-75" role="group" aria-label="">
        <input type="radio" class="btn-check"
               :name="`${propId}_checkbox`"
               :id="`${propId}_checkbox_off`"
               v-model="value"
               :value="false"
               autocomplete="off">
        <label class="btn btn-outline-primary" :for="`${propId}_checkbox_off`">
          {{ propOffTitle }}
        </label>

        <input type="radio" class="btn-check"
               :name="`${propId}_checkbox`"
               :id="`${propId}_checkbox_on`"
               v-model="value"
               :value="true"
               autocomplete="off">
        <label class="btn btn-outline-primary" :for="`${propId}_checkbox_on`">
          {{ propOnTitle }}
        </label>
      </div>
    </div>
  </div>
</template>